import React from "react";

import { animated } from "@react-spring/web";

import useSlides from "@app/common/hooks/useSlides";

import Stack from "@rui/Stack";

import { Container } from "./styles";
import type { UpsellModuleProps } from "./UpsellModule";
import UpsellModuleActions from "./UpsellModuleActions";
import UpsellModuleInnerContent from "./UpsellModuleInnerContent";

const AnimatedStack = animated(Stack);

const UpsellModuleCarousel = ({ slides }: { slides: UpsellModuleProps[] }) => {
  const { activeSlideIndex, jumpToSlide, transition } = useSlides({
    slides,
  });

  const { color, sx, cta, onDismiss, ...activeSlideProps } =
    slides[activeSlideIndex];

  return (
    <Container color={color} sx={sx}>
      <Stack position="relative">
        {/* Invisible sizer for content; the visible content is absolutely positioned
         and so won't force the container to expand as the content wraps */}
        <Stack visibility="hidden">
          <UpsellModuleInnerContent {...activeSlideProps} />
        </Stack>
        {transition((style) => (
          <AnimatedStack
            style={{
              ...style,
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
            }}
          >
            <UpsellModuleInnerContent {...activeSlideProps} />
          </AnimatedStack>
        ))}
      </Stack>
      <UpsellModuleActions
        cta={cta}
        onDismiss={onDismiss}
        slides={{
          activeSlide: activeSlideIndex,
          count: slides.length,
          jumpToSlide,
        }}
      />
    </Container>
  );
};

export default UpsellModuleCarousel;
